import { render, staticRenderFns } from "./ProfessionListCategory.vue?vue&type=template&id=462fc1c8&scoped=true&"
import script from "./ProfessionListCategory.vue?vue&type=script&lang=js&"
export * from "./ProfessionListCategory.vue?vue&type=script&lang=js&"
import style0 from "./ProfessionListCategory.vue?vue&type=style&index=0&id=462fc1c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462fc1c8",
  null
  
)

export default component.exports